/*
 *
 * UpfrontTdr constants
 *
 */
import { HeadingType } from './types';

export const BASE_ACTION_CONSTANT = 'app/UpfrontTdr';

export const DEFAULT_ACTION = `${BASE_ACTION_CONSTANT}/DEFAULT_ACTION`;

export const ENABLE_LOADER = `${BASE_ACTION_CONSTANT}/ENABLE_LOADER`;

export const DISABLE_LOADER = `${BASE_ACTION_CONSTANT}/DISABLE_LOADER`;

export const GET_UPFRONT_TDR = `${BASE_ACTION_CONSTANT}/GET_UPFRONT_TDR`;

export const GET_UPFRONT_TDR_URL = {
  method: 'GET',
  url: '/router/merchants/$merchantId$/pmr/payment-methods',
};

export const TDR_STATUS = {
  ADDED: 'ADDED',
  NOT_ADDED: 'NOT_ADDED',
};

export const HEADINGS: HeadingType[] = [
  {
    key: 'lastUpdatedOn',
    displayName: 'Last Modified',
    width: 0.07,
  },
  {
    key: 'paymentMethod',
    displayName: 'Payment Mode',
    width: 0.06,
  },
  // {
  //   key: 'tdrStatus',
  //   displayName: 'TDR Status',
  //   width: 0.04,
  // },
  // {
  //   key: 'statusCTA',
  //   displayName: '',
  //   width: 0.04,
  // },
  {
    key: 'tdrCTA',
    displayName: '',
    width: 0.8,
  },
];
